export const userRoles = {
    SUPERADMIN: "superadmin",
    TRIP_OPERATOR: "trip_operator",
    DATA_COLLECTOR: "data_collector",
    AREA_SUPERVISOR: "area_supervisor",
    ACCOUNT_MANAGER: "account_manager",
    SALES_REPRESENTATIVE: "sales_representative",
    SUPPLY_REPRESENTATIVE: "supply_representative",
    OPERATIONS_REPRESENTATIVE: "operations_specialist",
    PROJECT_MANAGER: "project_manager",
    FINANCE_SPECIALIST: "finance_specialist",
    QA_REVIEWER: ":reviewer",
    PRICING_SPECIALIST: "pricing_specialist",
};
